import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// declare const Plyr: any;
declare const Hls: any;
@Component({
  selector: 'app-video-preview-wrapper',
  templateUrl: './video-preview-wrapper.component.html',
  styleUrls: ['./video-preview-wrapper.component.scss']
})

export class VideoPreviewWrapperComponent implements OnInit{
  
  @Input() public url;
  @Input() public thumbnail;
  @Input() public content;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public preview;
  @Input() public localPreview;
  @Input() public localPreviewType;
  @Input() public ChatVideoMessageComing;
  @Input() public contentTypeTemp;

  
  
  constructor(private activeModal: NgbActiveModal) { }

  showVideo = false;

  ngOnInit() {
    this.showVideo = !this.isAdvertisement;
  }
  closeDialog() {
    this.activeModal.close();
  }
  change(value){
    this.showVideo = value;
  }
  // reference to the element itself, we use this to access events and methods
  // public streamUrl: String = 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8';
  // seekbarTracker: any = {
  //   duration: 0,
  //   time: 0,
  //   seekPercent: 0,
  //   hasDVR: false,
  // };
  // player: any;
  // seekTime: number;
  // hls: any;
  // levels = [0, 0, 0];
  // isHls: boolean = false;
  // currentLevel = [false,false,false];
  // // // video asset url
  // // @Input() url: any;

  // // declare player var
  // // private player: any;

  // // constructor initializes our declared vars
  // constructor(private activeModal: NgbActiveModal) {
  //   // this.url = false;
  //   // this.player = false;
  // }

  // ngOnInit() {
  //   if (this.thumbnail) {
  //     this.thumbnail = this.thumbnail;
  //   }
  //   else {
  //     this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
  //   }

  //   if (this.content.links_cloud && this.content.links_cloud.video_url.hls) {
  //     this.url = this.content.links_cloud.video_url.hls;
  //     this.isHls = true;
  //   }
  //   if (this.content.video_url && this.content.video_url.hls) {
  //     this.url = this.content.video_url.hls;
  //     this.isHls = true;
  //   }
  // }

  // // use ngAfterViewInit to make sure we initialize the videojs element
  // // after the component template itself has been rendered



  // // Functions associated with the player


  // changeResolution(level,index) {
  //   this.hls.currentLevel = level;
  //   this.currentLevel.forEach((element,i) => {
  //     if(index == i){
  //       this.currentLevel[i] = true;
  //     }
  //     else{
  //       this.currentLevel[i] = false;
  //     }
  //   });
  // }


  // async ngAfterViewInit() {

  //   // const source = 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8';
  //   const video: any = document.getElementById('sxmvideo');

  //   // For more options see: https://github.com/sampotts/plyr/#options
  //   // captions.update is required for captions to work with hls.js
  //   this.player = new Plyr(video, { captions: { active: true, update: true, language: 'en' } });
   
  //   if (!Hls.isSupported() || !this.isHls) {
  //     video.src = this.url;
  //   } else {

  //     var config = {
  //       autoStartLoad: true,
  //       startPosition: -1,
  //       debug: false,
  //       capLevelOnFPSDrop: true,
  //       capLevelToPlayerSize: true,
  //       defaultAudioCodec: undefined,
  //       initialLiveManifestSize: 1,
  //       maxBufferLength: 30,
  //       maxMaxBufferLength: 600,
  //       maxBufferSize: 60 * 1000 * 1000,
  //       maxBufferHole: 0.5,
  //       lowBufferWatchdogPeriod: 0.5,
  //       highBufferWatchdogPeriod: 3,
  //       nudgeOffset: 0.1,
  //       nudgeMaxRetry: 3,
  //       maxFragLookUpTolerance: 0.25,
  //       liveSyncDurationCount: 3,
  //       liveMaxLatencyDurationCount: Infinity,
  //       enableWorker: true,
  //       enableSoftwareAES: true,
  //       manifestLoadingTimeOut: 10000,
  //       manifestLoadingMaxRetry: 1,
  //       manifestLoadingRetryDelay: 1000,
  //       manifestLoadingMaxRetryTimeout: 64000,
  //       startLevel: undefined,
  //       levelLoadingTimeOut: 10000,
  //       levelLoadingMaxRetry: 4,
  //       levelLoadingRetryDelay: 1000,
  //       levelLoadingMaxRetryTimeout: 64000,
  //       fragLoadingTimeOut: 20000,
  //       fragLoadingMaxRetry: 6,
  //       fragLoadingRetryDelay: 1000,
  //       fragLoadingMaxRetryTimeout: 64000,
  //       startFragPrefetch: false,
  //       fpsDroppedMonitoringPeriod: 5000,
  //       fpsDroppedMonitoringThreshold: 0.2,
  //       appendErrorMaxRetry: 3,
  //       enableWebVTT: true,
  //       enableCEA708Captions: true,
  //       stretchShortVideoTrack: false,
  //       maxAudioFramesDrift: 1,
  //       forceKeyFrameOnDiscontinuity: true,
  //       abrEwmaFastLive: 3.0,
  //       abrEwmaSlowLive: 9.0,
  //       abrEwmaFastVoD: 3.0,
  //       abrEwmaSlowVoD: 9.0,
  //       abrEwmaDefaultEstimate: 500000,
  //       abrBandWidthFactor: 0.95,
  //       abrBandWidthUpFactor: 0.7,
  //       abrMaxWithRealBitrate: false,
  //       maxStarvationDelay: 4,
  //       maxLoadingDelay: 4,
  //       minAutoBitrate: 0,
  //       emeEnabled: false,
  //       widevineLicenseUrl: undefined,
  //       // requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess
  //     };
      
  //     // For more Hls.js options, see https://github.com/dailymotion/hls.js
  //     this.hls = new Hls(config);


  //     this.hls.loadSource(this.url);
  //     this.hls.attachMedia(video);
  //     this.hls.currentLevel = 2;
  //     this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
  //         // event control after loading
  //     });
  //     window['hls'] = this.hls;
  //     await video.play();
  //     this.levels[1] = Math.floor(this.hls.levels.length / 2);
  //     this.levels[2] = this.hls.levels.length - 1;
  //     if(this.hls.currentLevel == this.levels[0]){
  //       this.currentLevel[1] = false;
  //       this.currentLevel[0] = true;
  //       this.currentLevel[2] = false;
  //     }
  //     else if(this.hls.currentLevel > this.levels[0] && this.hls.currentLevel < this.levels[2]){
  //       this.currentLevel[1] = true;
  //       this.currentLevel[0] = false;
  //       this.currentLevel[2] = false;
  //     }
  //     else if(this.hls.currentLevel > this.levels[0] && this.hls.currentLevel > this.levels[1]){
  //       this.currentLevel[1] = false;
  //       this.currentLevel[0] = false;
  //       this.currentLevel[2] = true;
  //     }
  //     // Handle changing captions
  //     // console.log(this.player.config.quality);
  //     this.player.on('languagechange', () => {
  //       // Caption support is still flaky. See: https://github.com/sampotts/plyr/issues/994
  //       // setTimeout(() => this.hls.subtitleTrack = this.player.currentTrack, 50);
  //     });
  //   }
  // }


  // /**
  //  *   // this.player.on('timeupdate', this.handleListener);
  // }

  // handleListener(e){
  //   console.log(e.detail.plyr.ended);
  // }
  //  */
  // closeDialog() {
  //   this.player.destroy();
  //   this.activeModal.dismiss();
  // }

  // getDuration(player) {
  //   var seekable = player.seekable();
  //   return seekable && seekable.length ? seekable.end(0) - seekable.start(0) : 0;
  // }

  // onSeekPercentChange(player, seekPercent, duration) {
  //   var seekable = player.seekable();

  //   if (seekable && seekable.length) {
  //     // constrain currentTime
  //     player.currentTime(Math.max(0, Math.min(seekable.end(0), seekable.start(0) + (seekPercent * duration))));
  //   }
  // }

  // // isLive() {
  // //   if (!isFinite(this.player.duration())) {
  // //     return true;
  // //   }

  // //   var acceptableDelay = 30;
  // //   var seekable = this.player.seekable();
  // //   return seekable && seekable.length && seekable.end(0) - this.player.currentTime() < acceptableDelay;
  // // }

  // // ngOnDestroy() {

  // //   // this.player.dispose();
  // // }

  // // seek(n) {
  // //   this.player.currentTime(this.seekTime || 1266);
  // // }
  // // play(n) {

  // //   if (this.player.paused()) {
  // //     this.player.play();
  // //   }
  // //   else {
  // //     this.player.pause();
  // //   }
  // // }

  // // create() {
  // //   //     this.player.src({
  // //   //   src: 'https://oocache-live-delivery-ooyala.akamaized.net/out/u/d8npqvovi8we5/110326/U3cWNvZjE6xpWi6dq7FE2Q8B362hEbfl/en/cc984f46656c4ecc889711165c08b378.m3u8'
  // //   // });

  // //   this.player.src({
  // //     src: ' https://oocache-live-delivery-ooyala.akamaized.net/out/u/d8npqvovi8we5/110326/N5cmNvZjE6U3nnGeGa0yVC66Gaw-NWxS/en/fda8ba2dd9554ad2b668277730469fea.m3u8'

  // //   });
  // //   this.player.play();
  // //   // this.player.controlBar.currentTimeDisplay();  
  // // }

  // // destroy() {

  // // }
}
